<template>
  <div class="sub-com-wrap">
    <div class="title">
      <div class="sep"></div>
      待确认授权
    </div>

    <div class="content">
      <el-table
          ref="tableRef"
          :data="tableShowList"
          class="confirm-user-table"
          style="margin-top: 10px;"
          border
      >
        <el-table-column type="index" label="序号" fixed="left" align="center" width="60"/>

        <el-table-column label="统一信用代码" align="center" min-width="180">
          <template #default="{row}">
            <span>91110104533585261H</span>
          </template>
        </el-table-column>

        <el-table-column label="纳税人名称" align="center" min-width="180">
          <template #default="{row}">
            <span>北京仁和服饰有限公司</span>
          </template>
        </el-table-column>


        <el-table-column label="开票人名称" align="center" prop="ticName" min-width="100"/>

        <el-table-column label="身份类型" align="center" prop="roleType" min-width="120"/>

        <el-table-column label="发起时间" align="center" prop="createTime" min-width="120"/>

        <el-table-column
            fixed="right"
            label="操作" align="center"
            min-width="130">
          <template #default="{row}">
            <el-button
                size="small"
                type="primary"
                @click="confirm(row)"
            >确认
            </el-button>

            <el-popconfirm
                title="拒绝成为办税人员吗？"
                @confirm="deleteRow(row)"
            >
              <template #reference>
                <el-button
                    size="small"
                    type="danger"
                >拒绝
                </el-button>
              </template>
            </el-popconfirm>

          </template>
        </el-table-column>

      </el-table>
    </div>

    <to-grant-enter-confirm-dialog
        v-model:visible="confirmVis"
        :current-row="currentRow"
        @confirm="onConfirm"
    />
  </div>
</template>

<script setup>
import {ElMessage} from "element-plus";
import ToGrantEnterConfirmDialog from "./toGrantEnterConfirmDialog.vue";
import {useTaxUserStore} from "./addTaxPina.js";

const store = useTaxUserStore()
const {userAnswer} = storeToRefs(store);

const tableShowList = computed(() => {
  return userAnswer.value.filter(f => f.isAuth != '是')
})

const confirmVis = ref(false)
const currentRow = ref({})

function confirm(row) {
  currentRow.value = row
  confirmVis.value = true
}

function deleteRow(row) {
  ElMessage.success('操作成功')
  row.isAuth = '否'
}

function onConfirm() {
  ElMessage.success('授权成功')
  currentRow.value.isAuth = '是'
}
</script>

<style scoped lang="scss">
.sub-com-wrap {
  height: 100%;
  background-color: #FFFFFF;
  box-sizing: border-box;
  padding: 18px 20px;

  .title {
    font-size: 20px;
    line-height: 30px;
    color: #303133;
    font-weight: 700;
    display: flex;
    align-items: center;

    .sep {
      width: 5px;
      background-color: #409eff;
      margin-right: 8px;
      height: 20px;
      border-radius: 20%;
    }
  }

  .content {
    margin-top: 20px;

    :deep(.confirm-user-table) {
      .el-table__header {
        th.el-table__cell {
          background-color: #f9fafd;
        }
      }
    }
  }

}
</style>
